module.exports = __webpack_public_path__ + "img/17_108.5a43b6ab.png";